<template>
  <el-config-provider :locale="zhCn">
    <RouterView />
  </el-config-provider>
</template>
<script setup lang="ts">
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn.mjs';
import { onMounted } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useRoute } from 'vue-router';
import modules from '@/router/modules';

/**
 * css iconfont
 * https://www.iconfont.cn/manage/index?spm=a313x.home_index.i3.22.58a33a81pX2j3X&manage_type=myprojects&projectId=4639239
 */

const userStore = useUserStore();
const route = useRoute();

onMounted(async () => {
  // 如果有 token 且不在登录页，则刷新用户信息
  if (userStore.getToken && route.path !== '/login') {
    await userStore.refreshUserInfo();
    // 初始化动态路由到 store
    userStore.setAddRouters(modules as any);
  }
});
</script>

<style lang="less">
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
    .size;
  }
}
</style>
